<template>
  <div class="main">
    <el-row>
      <!-- 查询条件 -->
      <el-col class="pagin" ref="query" v-if="userInfo.userLevel=='2'">
        <el-row class="mb5 mt2 ml2">
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">名称:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.userFactName" size="small" placeholder="名称" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">编码:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.sn" size="small" placeholder="编码" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">状态:</div>
            <div class="pl4-6 width-200">
              <el-select clearable v-model="formQuery.status" placeholder="请选择状态" size="small">
                <el-option v-for="(item, index) in dictStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">联系人:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.contacts" size="small" placeholder="联系人" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">电话:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.mobile" size="small" placeholder="电话" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">创建时间:</div>
            <div class="pl4-6 width-200">
              <el-date-picker
                style="width: 205px;"
                :clearable="true"
                v-model="createTimeDate"
                :picker-options="disabledAfterNow"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div class="inline-block mr4">
            <el-button v-if="checkPermission(funcData, 'query')" size="small" type="primary" icon="el-icon-search" @click="onQuery">查找</el-button>
            <el-button v-if="checkPermission(funcData, 'add')" size="small" type="primary" icon="el-icon-plus" @click="onShowAdd">添加</el-button>
          </div>
          <!-- 批量操作按扭 -->
          <el-dropdown v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')" size="small" type="primary" trigger="click">
            <el-button type="primary" size="small">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="checkPermission(funcData, 'batchRemove')" class="px10" @click.native="onBatchRemove">批量删除</el-dropdown-item>
              <el-dropdown-item v-if="checkPermission(funcData, 'batchEnable')" class="px10" @click.native="onBatchEnable">批量启用</el-dropdown-item>
              <el-dropdown-item v-if="checkPermission(funcData, 'batchDisable')" class="px10" @click.native="onBatchDisable">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link type="primary" @click="showMore=!showMore" style="margin-left:10px;">{{showMore?'收起∧':'展开∨'}}</el-link>
        </el-row>
      </el-col>

      <!-- 表格  -->
      <el-col v-if="!checkPermission(funcData, 'query')" :style="{height: pageHeight,lineHeight: pageHeight}" class="noPer">没有列表查询权限</el-col>
      <el-col v-else>
        <el-table
          ref="table"
          :key="Math.random()"
          v-loading="pageLoading"
          element-loading-text="拼命加载中"
          size="mini"
          stripe
          border
          style="width: 100%"
          :height="pageHeight"
          :data="dataList"
          :header-cell-class-name="onHeaderClass"
          @sort-change="onSortChange"
          @selection-change="onSelectionChange"
          ><!-- :default-sort = "{prop: 'date', order: 'descending'}" -->

          <el-table-column
            v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')"
            type="selection"
            width="45"></el-table-column>

          <el-table-column align="center" label="序号" type="index"></el-table-column>

          <el-table-column width="180px" align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(funcData, 'detail')" size="mini" title="查看" circle type="success" icon="el-icon-document" @click="onDetail(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'modify')" size="mini" title="编辑" circle type="warning" icon="el-icon-edit" @click="onShowEdit(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'remove')" size="mini" title="删除" circle type="danger" icon="el-icon-delete" @click="onPageRemove(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'userStore')" size="mini" title="仓库" circle type="primary" icon="el-icon-s-home" @click="$router.push({name:'userplatProdUserstore', query:{userFactId:scope.row.userFactId}})"></el-button>
              <el-button v-if="checkPermission(funcData, 'factoryLogin')" size="mini" title="登录管理" circle type="info" icon="el-icon-user" @click="$router.push({name:'userplatProdFactorylogin', query:{objId:scope.row.userFactId}})"></el-button>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="userFactName"
            label="名称"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="sn"
            label="编码"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="status"
            label="状态"
            sortable="custom"
            >
            <template slot-scope="scope">
              <el-switch
                v-if="checkPermission(funcData, 'enable,disable')"
                :disabled="((scope.row.status!='1' && !checkPermission(funcData, 'enable')) || (scope.row.status=='1' && !checkPermission(funcData, 'disable')))"
                style="margin-right: 5px;"
                @change="onSwitch(scope.$index, scope.row)"
                v-model="scope.row.switch"
                active-color="#409eff"
                inactive-color="#dcdfe6">
              </el-switch>
              <el-tag size="small" type="success" v-if="scope.row.status == '1'">{{scope.row.status|dict(dictStatus)}}</el-tag>
              <el-tag size="small" type="danger" v-else>{{scope.row.status|dict(dictStatus)}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contacts"
            label="联系人"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="mobile"
            label="电话"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="创建时间"
            sortable="custom"
            >
          </el-table-column>
        </el-table>
      </el-col>

      <!-- 分页 -->
      <el-col class="pagination">
        <el-pagination
          background
          :current-page="pageParam.pageNo"
          :page-sizes="[30, 50, 100, 200, 500, 1000]"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          layout="prev, pager, next, total, jumper, sizes"
          :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 详情弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" width="700px" top="8vh">
      <template slot="title"><i class="el-icon-document" /> 工厂详情</template>
      <el-descriptions class="detail-div" :column="2" size="small" border labelClassName="detail-label" contentClassName="detail-content">
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-warning-outline"></i>工厂ID</template>
          {{dataDetail.userFactId}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>工厂名称</template>
          {{dataDetail.userFactName}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label"><i class="el-icon-tickets"></i>工厂描叙</template>
          {{dataDetail.userFactDesc}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label"><i class="el-icon-tickets"></i>编码</template>
          {{dataDetail.sn}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label"><i class="el-icon-office-building"></i>地址</template>
          {{dataDetail.addr}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-open"></i>状态</template>
          {{dataDetail.status|dict(dictStatus)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user"></i>联系人</template>
          {{dataDetail.contacts}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-mobile-phone"></i>电话</template>
          {{dataDetail.mobile}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>微信号</template>
          {{dataDetail.wechat}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user-solid"></i>最后操作员</template>
          {{dataDetail.operatorId}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>创建时间</template>
          {{dataDetail.createTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>更新时间</template>
          {{dataDetail.updateTime}}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogAdd" width="700px" @closed="onResetForm('formAdd')" top="8vh">
      <template slot="title"><i class="el-icon-document-add" /> 添加工厂</template>
      <el-form :model="formAdd" ref="formAdd" :rules="formAddRules" size="small" inline label-width="110px">
        <el-form-item label="工厂名称" prop="userFactName">
          <el-input class="width-2-2" v-model="formAdd.userFactName" placeholder="请输入工厂名称" maxlength="64" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="工厂描叙" prop="userFactDesc">
          <el-input class="width-2-2" type="textarea" v-model="formAdd.userFactDesc" placeholder="请输入工厂描叙" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="sn">
          <el-input class="width-2-2" v-model="formAdd.sn" placeholder="请输入编码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="addr">
          <el-input class="width-2-2" v-model="formAdd.addr" placeholder="请输入地址" maxlength="512" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input class="width-2-1" v-model="formAdd.contacts" placeholder="请输入联系人" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input class="width-2-1" v-model="formAdd.mobile" placeholder="请输入电话" maxlength="11" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="wechat">
          <el-input class="width-2-2" v-model="formAdd.wechat" placeholder="请输入微信号" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-checkbox class="width-2-2" label="创建登录账号" v-model="createLoginUser"></el-checkbox>
        </el-form-item>
        <el-form-item label="登录账号" prop="loginName" v-if="createLoginUser">
          <el-input class="width-2-1" v-model="formAdd.loginName" placeholder="请输入登录账号" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="loginPwd" v-if="createLoginUser">
          <el-input class="width-2-1" v-model="formAdd.loginPwd" placeholder="请输入登录密码" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitAdd()" size="small">提 交</el-button>
        <el-button @click="dialogAdd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogModify" width="700px" @closed="onResetForm('formEdit')" top="8vh">
      <template slot="title"><i class="el-icon-edit" /> 编辑工厂</template>
      <el-form :model="formEdit" ref="formEdit" :rules="formEditRules" size="small" inline label-width="110px">
        <el-form-item label="工厂名称" prop="userFactName">
          <el-input class="width-2-2" v-model="formEdit.userFactName" placeholder="请输入工厂名称" maxlength="64" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="工厂描叙" prop="userFactDesc">
          <el-input class="width-2-2" type="textarea" v-model="formEdit.userFactDesc" placeholder="请输入工厂描叙" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="sn">
          <el-input class="width-2-2" v-model="formEdit.sn" placeholder="请输入编码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="addr">
          <el-input class="width-2-2" v-model="formEdit.addr" placeholder="请输入地址" maxlength="512" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input class="width-2-1" v-model="formEdit.contacts" placeholder="请输入联系人" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input class="width-2-1" v-model="formEdit.mobile" placeholder="请输入电话" maxlength="11" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="wechat">
          <el-input class="width-2-2" v-model="formEdit.wechat" placeholder="请输入微信号" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitEdit()" size="small">提 交</el-button>
        <el-button @click="onResetEdit" size="small">重 置</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'userplatProdUserfactory',
  data () {
    return {
      menuName: 'userplatProdUserfactory',
      formQuery: { // 查询对象
        userFactName: '', // 工厂名称
        sn: '', // 编码
        status: '', // 状态
        contacts: '', // 联系人
        mobile: '', // 电话
        createTimeBegin: '', // 创建时间-开始时间
        createTimeEnd: '' // 创建时间-结束时间
      },
      createLoginUser: false, // 仓库登录账号
      formAdd: { // 新增对象
        loginName: '', // 登录账号
        loginPwd: '', // 登录密码
        userFactName: '', // 工厂名称
        userFactDesc: '', // 工厂描叙
        sn: '', // 编码
        addr: '', // 地址
        contacts: '', // 联系人
        mobile: '', // 电话
        wechat: '' // 微信号
      },
      formAddRules: { // 新增规则
        userFactName: [{ required: true, message: '请输入工厂名称', trigger: 'blur' }],
        sn: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        loginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        loginPwd: [{ required: true, message: '请输入登录密码', trigger: 'blur' }]
      },
      formEditRules: { // 更新规则
        userFactName: [{ required: true, message: '请输入工厂名称', trigger: 'blur' }],
        sn: [{ required: true, message: '请输入编码', trigger: 'blur' }]
      },
      dictStatus: [], // 状态
      idName: 'userFactId',
      httpUrl: '/prod/userFactory',
      httpUri: {
      }
    }
  },
  watch: {
    createLoginUser: {
      handler (curVal, oldVal) {
        if (!curVal) {
          this.formAdd.loginName = ''
          this.formAdd.loginPwd = ''
        }
      }
    }
  },
  mounted () {
    this.getSysDict('STATUS_TYPE', 'dictStatus', 'getStatus')
  },
  methods: {
    removeTip (row) {
      return `工厂名称：${row.userFactName}<br/>编码：${row.sn}<br/>确认要删除该工厂？`
    }
  }
}
</script>

<style scoped>
@import "../../assets/page.css";

div.width-2-2 {
    width: 520px;
}
</style>
